// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterBlock__E6oBh {
  background-color: var(--header-surface);
  border-right: 1px solid var(--tables-primary-row-stroke);
  overflow: hidden;
}

.filterHead__Npzuk {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background-color: var(--tables-title-surface);
  border-bottom: 1px solid var(--tables-title-stroke);
}

.filterHeadTitle__HV8kA {
  font-size: 11px;
  line-height: 16px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.filterBody__augXF {
  height: calc(100% - 45px);
  overflow-y: auto;
}
.filterBody__augXF::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.filterBody__augXF::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.filterBody__augXF::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.filterBody__augXF::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.filterBodyShort__khGs9 {
  height: calc(100% - 90px);
}

.facilitiesTree__7hnvQ {
  border: none;
}
.facilitiesTree__7hnvQ .rc-tree-treenode {
  display: flex;
  align-items: center;
  padding: 8px 20px;
}
.facilitiesTree__7hnvQ .rc-tree-treenode:has(span .rc-tree-indent-unit) {
  background-color: var(--tables-secondary-row-sub-title-surface);
}
.facilitiesTree__7hnvQ .rc-tree-treenode.rc-tree-treenode-selected {
  background-color: var(--tables-primary-row-surface-selected);
  border-left: 2px solid var(--buttons-surface);
}
.facilitiesTree__7hnvQ .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper {
  font-weight: 500 !important;
  color: var(--tables-primary-row-text-main) !important;
  position: relative;
}
.facilitiesTree__7hnvQ .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper::after {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  top: 0;
  right: 0px;
  background-color: var(--buttons-surface);
  border-radius: 50%;
}
.facilitiesTree__7hnvQ .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper .rc-tree-title {
  position: relative;
}
.facilitiesTree__7hnvQ .rc-tree-treenode .rc-tree-node-content-wrapper {
  font-weight: 500;
  color: var(--tables-primary-row-text-main);
  width: calc(100% - 20px);
  overflow: hidden;
}
.facilitiesTree__7hnvQ .rc-tree-treenode .rc-tree-node-content-wrapper .rc-tree-title {
  width: auto;
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.facilitiesTree__7hnvQ .rc-tree-treenode .rc-tree-node-selected {
  font-weight: 700;
  background-color: unset;
  box-shadow: none;
  opacity: 1;
  pointer-events: none;
}
.facilitiesTree__7hnvQ .rc-tree-treenode .rc-tree-switcher-noop {
  display: none !important;
}
.facilitiesTree__7hnvQ .rc-tree-treenode span.rc-tree-switcher {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  order: 2;
  margin-left: auto;
  background-image: none;
}
.facilitiesTree__7hnvQ .rc-tree-treenode span.rc-tree-switcher svg path {
  stroke: var(--tables-primary-row-icon) !important;
}
.facilitiesTree__7hnvQ .rc-tree-list {
  overflow: hidden;
}

.filterFooter__udKMY {
  height: 45px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: var(--tables-secondary-row-sub-title-surface);
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/SensorsFacilityFilter/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,uCAAA;EACA,wDAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,yBAAA;EACA,gBAAA;AAzEF;AACE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAEE;EACE,+BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,kBAAA;AAFJ;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,YAAA;AA1DF;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AA3DN;AA6DM;EACE,+DAAA;AA3DR;AA8DM;EACE,4DAAA;EACA,6CAAA;AA5DR;AAgEQ;EACE,2BAAA;EACA,qDAAA;EACA,kBAAA;AA9DV;AAgEU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wCAAA;EACA,kBAAA;AA9DZ;AAiEU;EACE,kBAAA;AA/DZ;AAoEM;EACE,gBAAA;EACA,0CAAA;EACA,wBAAA;EACA,gBAAA;AAlER;AAoEQ;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlEV;AAsEM;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;AApER;AAuEM;EACE,wBAAA;AArER;AAwEM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;AAtER;AAwEQ;EACE,iDAAA;AAtEV;AA0EI;EACE,gBAAA;AAxEN;;AA6EA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,+DAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.filterBlock {\n  background-color: var(--header-surface);\n  border-right: 1px solid var(--tables-primary-row-stroke);\n  overflow: hidden;\n}\n\n.filterHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 20px;\n  background-color: var(--tables-title-surface);\n  border-bottom: 1px solid var(--tables-title-stroke);\n}\n\n.filterHeadTitle {\n  font-size: 11px;\n  line-height: 16px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.filterBody {\n  height: calc(100% - 45px);\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.filterBodyShort {\n  height: calc(100% - 90px);\n}\n\n.facilitiesTree {\n  border: none;\n\n  :global {\n    .rc-tree-treenode {\n      display: flex;\n      align-items: center;\n      padding: 8px 20px;\n\n      &:has(span .rc-tree-indent-unit) {\n        background-color: var(--tables-secondary-row-sub-title-surface);\n      }\n\n      &.rc-tree-treenode-selected {\n        background-color: var(--tables-primary-row-surface-selected);\n        border-left: 2px solid var(--buttons-surface);\n      }\n\n      &.filter-node {\n        .rc-tree-node-content-wrapper {\n          font-weight: 500 !important;\n          color: var(--tables-primary-row-text-main) !important;\n          position: relative;\n\n          &::after {\n            content: '';\n            width: 5px;\n            height: 5px;\n            position: absolute;\n            top: 0;\n            right: 0px;\n            background-color: var(--buttons-surface);\n            border-radius: 50%;\n          }\n\n          .rc-tree-title {\n            position: relative;\n          }\n        }\n      }\n\n      .rc-tree-node-content-wrapper {\n        font-weight: 500;\n        color: var(--tables-primary-row-text-main);\n        width: calc(100% - 20px);\n        overflow: hidden;\n\n        .rc-tree-title {\n          width: auto;\n          max-width: 95%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n\n      .rc-tree-node-selected {\n        font-weight: 700;\n        background-color: unset;\n        box-shadow: none;\n        opacity: 1;\n        pointer-events: none;\n      }\n\n      .rc-tree-switcher-noop {\n        display: none !important;\n      }\n\n      span.rc-tree-switcher {\n        width: 24px;\n        height: 24px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        order: 2;\n        margin-left: auto;\n        background-image: none;\n\n        svg path {\n          stroke: var(--tables-primary-row-icon) !important;\n        }\n      }\n    }\n    .rc-tree-list {\n      overflow: hidden;\n    }\n  }\n}\n\n.filterFooter {\n  height: 45px;\n  padding: 0 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterBlock": `filterBlock__E6oBh`,
	"filterHead": `filterHead__Npzuk`,
	"filterHeadTitle": `filterHeadTitle__HV8kA`,
	"filterBody": `filterBody__augXF`,
	"filterBodyShort": `filterBodyShort__khGs9`,
	"facilitiesTree": `facilitiesTree__7hnvQ`,
	"filterFooter": `filterFooter__udKMY`
};
module.exports = ___CSS_LOADER_EXPORT___;
